module.exports = __webpack_public_path__ + "img/fav.850e3110.png";